import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { I18nPipe } from '../../pipes/i18n.pipe';

type FooterVariant = 'default' | 'auth';

interface FooterLink {
  text: string;
  url: string;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

@Component({
  selector: 'umkt-footer',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  @Input() variant: FooterVariant = 'default';
  
  currentYear: number = new Date().getFullYear();

  companyInfo = {
    name: 'Claro',
    year: this.currentYear,
  };

  columns: FooterColumn[] = [
    {
      title: 'components.footer.privacyPolicyTitle',
      links: [
        {
          text: 'components.footer.privacyPolicy',
          url: 'https://www.claro.com.br/privacidade/politica-de-privacidade',
        },
        {
          text: 'components.footer.privacyPortal',
          url: 'https://www.claro.com.br/privacidade',
        },
      ],
    },
    {
      title: '',
      links: [],
    },
    {
      title: '',
      links: [],
    },
  ];

  /** Keep for auth variant backward compatibility */
  privacyLinks = this.columns[0].links;
}
